//L&TT home link route only
export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis"
//